<template>
  <div id="login">
    <div class="front" v-if="!isMobile">
      <div class="login-icon">
        <div class="title">
          <div class="main-title">萧 银 案 件 管 理 系 统</div>
          <div class="min-title">XIAOYIN CASE MANAGEMENT SYSTEM</div>
        </div>
      </div>
      <div class="login-center">
        <a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit"
          ref="normal_login">
          <div class="htit">欢迎登录</div>
          <a-form-item class="itemli">
            <div class="input-glow">
              <div slot="prefix" class="icon user" />
              <input class="form-input" v-decorator="[
                'uname',
                { rules: [{ required: true, message: '请输入用户名!' }] },
              ]" placeholder="请输入用户名" :class="{ focus: focus == 0 }" @focus="focus = 0" @blur="focus = 2" />
            </div>
          </a-form-item>
          <a-form-item class="itemli">
            <div class="input-glow">
              <div slot="prefix" class="icon passo" />
              <input class="form-input" v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码!' }] },
              ]" :type="eyeStatus" placeholder="请输入密码" :class="{ focus: focus == 1 }" @focus="focus = 1"
                @blur="focus = 2" />
                <div  class="eye" @click="switchEye">
                  <a-icon type="eye" v-if="!eyeStatus" />
                  <a-icon type="eye-invisible"  v-else />
                </div>
            </div>
          </a-form-item>
          <a-form-item class="itemli">
            <div class="code-card">
              <div class="input-glow-code">
                <div slot="prefix" class="icon captcha" />
                <input class="form-input" v-decorator="['captcha', { rules: [{ required: true, message: '请输入验证码!' }] }]"
                  placeholder="请输入验证码" :class='{ "focus": focus == 2 }' @focus="focus = 2" @blur="focus = 2"
                  maxLength="4" />
              </div>
              <div class="getcode-btn" @click="refreshCaptcha">
                <img :src="image" id="cat"/>
              </div>
            </div>
          </a-form-item>
          <a-form-item>
            <div class="login-btn">
              <div class="points_wrapper">
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
              </div>
              <a-button class="btn inner" block html-type="submit">
                <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5">
                  <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37">
                  </polyline>
                </svg>
                立即登录</a-button>
            </div>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div v-else>
      <div class="login-center-mobile">
        <div class="title">
          <div class="main-title">萧 银 案 件 管 理 系 统</div>
          <div class="min-title">XIAOYIN CASE MANAGEMENT SYSTEM</div>
        </div>
        <a-form id="components-form-demo-normal-login" :form="form" class="login-form-mobile" @submit="handleSubmit"
          ref="normal_login">
          <div class="htit">欢迎登录</div>
          <a-form-item class="itemli">
            <div class="input-glow">
              <div slot="prefix" class="icon-mobile user" />
              <input class="form-input" v-decorator="[
                'uname',
                { rules: [{ required: true, message: '请输入用户名!' }] },
              ]" placeholder="请输入用户名" :class="{ focus: focus == 0 }" @focus="focus = 0" @blur="focus = 2" />
            </div>
          </a-form-item>
          <a-form-item class="itemli">
            <div class="input-glow">
              <div slot="prefix" class="icon-mobile passo" />
              <input class="form-input" v-decorator="[
                'password',
                { rules: [{ required: true, message: '请输入密码!' }] },
              ]" :type="eyeStatus" placeholder="请输入密码" :class="{ focus: focus == 1 }" @focus="focus = 1"
                @blur="focus = 2" />
                <div  class="eye" @click="switchEye">
                  <a-icon type="eye" v-if="!eyeStatus" />
                  <a-icon type="eye-invisible"  v-else />
                </div>
            </div>
          </a-form-item>
          <a-form-item class="itemli">
            <div class="code-card">
              <div class="input-glow-code">
                <div slot="prefix" class="icon-mobile captcha" />
                <input class="form-input" maxLength="4"
                  v-decorator="['captcha', { rules: [{ required: true, message: '请输入验证码!' }] }]" placeholder="请输入验证码"
                  :class='{ "focus": focus == 2 }' @focus="focus = 2" @blur="focus = 2" />
              </div>
              <div class="getcode-btn" @click="refreshCaptcha">
                <img :src="image" id="cat"/>
              </div>
            </div>
          </a-form-item>
          <!-- <a-form-item> -->
          <div class="login-btn-mobile">
            <div class="points_wrapper">
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
              <i class="point"></i>
            </div>
            <a-button class="btn-code inner" block html-type="submit">
              <svg class="icon-mobile" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5">
                <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37">
                </polyline>
              </svg>
              立即登录</a-button>
          </div>
          <!-- </a-form-item> -->
        </a-form>
      </div>
    </div>
    <div class="footer">
      <a style="width: 200px" href="https://beian.miit.gov.cn" target="_blank"><img
          src="../assets/img/gh.png" />浙ICP备2022024828号</a>
    </div>
  </div>
</template>
<script>
import $http from "superagent";
import { Tacitly } from "@/assets/js/Tacitly";
import watermark from "@/assets/js/watermark.js";
import store from "../store/index";
import { captcha } from "@/server/api";
import { userLogLast } from "@/server/user"
export default {
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  data() {
    return {
      focus: 2,
      isMobile: false,
      viewportWidth: 0,
      viewportHeight: 0,
      screenWidth: 0,
      screenHeight: 0,
      codeImg: "",
      key: "",
      captcha: "",
      isLoading: false,
      image: '',
      eyeStatus:'password',
      isSubmitting: false
    }
  },
  created() {
    this.getCaptcha();
    localStorage.clear();
    this.$store.commit("SET_WATERMARKS", { bg1: "", bg2: "" });
  },
  computed: {
    // 根据屏幕尺寸动态调整容器样式
    containerStyle() {
      return {
        width: this.isMobile ? "90%" : "300px",
        padding: this.isMobile ? "1rem" : "2rem",
      };
    },
  },
  mounted() {
    // 初始化屏幕尺寸
    this.updateScreenSize();

    // 监听窗口大小变化
    this.resizeHandler = () => {
      // 防抖处理，避免频繁触发
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.updateScreenSize();
      }, 100);
    };

    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    // 更新屏幕尺寸信息
    updateScreenSize() {
      // 获取视口尺寸
      this.viewportWidth = window.innerWidth;
      this.viewportHeight = window.innerHeight;

      // 获取屏幕分辨率
      this.screenWidth = screen.width;
      this.screenHeight = screen.height;

      // 判断是否为移动端（以768px为界）
      this.isMobile = this.viewportWidth < 768;
    },
    switchEye(){
      if(this.eyeStatus == 'password'){
        this.eyeStatus = ''
      }else{
        this.eyeStatus = 'password'
      }
      
    },
    getCaptcha() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      captcha()
        .then((res) => {
          this.key = res.key;
          document.getElementById("cat").src = res.image
          this.image = res.image
        })
        .catch((err) => { })
        .finally(() => {
          // 无论成功失败，都释放锁
          this.isLoading = false;
        });
    },
    refreshCaptcha() {
      this.getCaptcha();
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.isSubmitting) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isSubmitting = true;
          this.$message.loading({ content: '正在登录', key: 'updatable', duration: 0 });
          $http.post(Tacitly.Base_Port + "auth/password_login").set("Content-Type", "application/x-www-form-urlencoded").send(
            {
              uname: values.uname,
              password: values.password,
              captcha: values.captcha,
              key: this.key
            }
          ).end((err, res) => {
            let data = res.body;
            if (data.code == "0000") {
              this.isSubmitting = true;
              localStorage.setItem("t", data.data.token)
              if (!data.data.user.view) {
                data.data.user.view = []
              }
              let nuser = JSON.stringify(data.data.user)
              localStorage.setItem("user", nuser)
              this.$store.dispatch("setuser", data.data.user)
              setTimeout(e => {
                this.$message.success({ content: '登录成功', key: 'updatable' });
                this.image = ''
                this.$router.push({ name: 'home' })
                store.dispatch("updateWatermarks"); // 调用 Vuex action 重新计算水印
              }, 500)
              this.getUserLogLast()
            } else {
              this.isSubmitting = false;
              this.$message.error({ content: res.body.msg, key: 'updatable' });
              this.getCaptcha()
              // this.$message.error(data.msg)
            }
          });
        }else{
          this.isSubmitting = false;
        }
      });
    },
    getUserLogLast(){
      userLogLast().then((res) => {
        this.$notification.open({
          message: `欢迎回来！${res.record.account}`,
          description: <div>上次登录时间：{res.record.last_time || '未知'}<br/>
          IP地址：{res.record.login_ip || '未知'}<br/>
          登录地点：{res.record.login_location || '未知'}</div>,
          icon: <a-icon type="smile" style="color: #1d8bfe" />,
          duration:8
        });
      })
    }
  },
};
</script>
<style lang="less">
.notification-with-newlines .ant-notification-notice-description {
    white-space: pre-line;
    line-height: 1.6;
}
.points_wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.points_wrapper .point {
  bottom: -10px;
  position: absolute;
  animation: floating-points infinite ease-in-out;
  pointer-events: none;
  width: 2px;
  height: 2px;
  background-color: #fff;
  border-radius: 9999px;
}

@keyframes floating-points {
  0% {
    transform: translateY(0);
  }

  85% {
    opacity: 0;
  }

  100% {
    transform: translateY(-55px);
    opacity: 0;
  }
}

.points_wrapper .point:nth-child(1) {
  left: 10%;
  opacity: 1;
  animation-duration: 2.35s;
  animation-delay: 0.2s;
}

.points_wrapper .point:nth-child(2) {
  left: 30%;
  opacity: 0.7;
  animation-duration: 2.5s;
  animation-delay: 0.5s;
}

.points_wrapper .point:nth-child(3) {
  left: 25%;
  opacity: 0.8;
  animation-duration: 2.2s;
  animation-delay: 0.1s;
}

.points_wrapper .point:nth-child(4) {
  left: 44%;
  opacity: 0.6;
  animation-duration: 2.05s;
}

.points_wrapper .point:nth-child(5) {
  left: 50%;
  opacity: 1;
  animation-duration: 1.9s;
}

.points_wrapper .point:nth-child(6) {
  left: 75%;
  opacity: 0.5;
  animation-duration: 1.5s;
  animation-delay: 1.5s;
}

.points_wrapper .point:nth-child(7) {
  left: 88%;
  opacity: 0.9;
  animation-duration: 2.2s;
  animation-delay: 0.2s;
}

.points_wrapper .point:nth-child(8) {
  left: 58%;
  opacity: 0.8;
  animation-duration: 2.25s;
  animation-delay: 0.2s;
}

.points_wrapper .point:nth-child(9) {
  left: 98%;
  opacity: 0.6;
  animation-duration: 2.6s;
  animation-delay: 0.1s;
}

.points_wrapper .point:nth-child(10) {
  left: 65%;
  opacity: 1;
  animation-duration: 2.5s;
  animation-delay: 0.2s;
}

.inner {
  z-index: 2;
  gap: 6px;
  position: relative;
  width: 100%;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  transition: color 0.2s ease-in-out;
}

.inner svg.icon {
  width: 18px;
  height: 18px;
  transition: fill 0.1s linear;
}

.inner svg.icon-mobile {
  width: 18px;
  height: 18px;
  transition: fill 0.1s linear;
}

.button:focus svg.icon,
.button:focus svg.icon-mobile {
  fill: white;
}

.btn:hover svg.icon {
  fill: transparent;
  animation: dasharray 1s linear forwards, filled 0.1s linear forwards 0.95s;
}

.btn-code,
.icon-mobile {
  fill: transparent;
  animation: dasharray 2s linear infinite, filled 0.8s linear 1.5s infinite;
}

@keyframes dasharray {
  from {
    stroke-dasharray: 0 0 0 0;
  }

  to {
    stroke-dasharray: 68 68 0 0;
  }
}

@keyframes filled {
  to {
    fill: white;
  }
}

#login {
  .ant-input-affix-wrapper .ant-input {
    border: 0 none;
    box-shadow: none !important;
    border-bottom: 1px solid #dbdcde;
    padding-left: 40px;
    height: 60px;
    font-size: 16px;
    border-radius: 0;
  }

  .ant-form-explain {
    position: absolute;
    margin-top: 10px;
    margin-left: 10px;
  }

  .focus .ant-input {
    border-bottom: 1px solid #1d8bfe;
  }

  .ant-input-affix-wrapper .ant-input-prefix {
    left: 5px;
  }
}
</style>
<style lang="less" scoped>
#login {
  // background: url("../assets/img/login.png") no-repeat;
  background: url("https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/login-bg.png") no-repeat;
  background-size: cover;
  position: relative;
  width: 100vw;
  height: 100vh;
  // margin: 0;
  // padding: 0;
  // overflow: hidden;
}

.footer {
  position: absolute;
  bottom: 60px;
  // text-align: center;
  font-size: 14px;
  display: flex;
  justify-content: center;

  a {
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 10px;
    }
  }

  line-height: 20px;
  z-index: 1111;
  width: 100%;
}

.front {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* 使元素相对于自身中心定位，实现真正居中 */
  width: 1200px;
  z-index: 2;
  display: flex;

  .login-icon {
    width: 700px;
    height: 690px;
    border-radius: 10px 0 0 10px;
    backdrop-filter: blur(-200px);
    background: url("https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/login-icon.png") no-repeat;
    background-size: cover;

    .title {
      margin-top: 460px;
      text-align: center;
      color: #ffffff;

      .main-title {
        margin-bottom: 10px;
        font-size: 34px;
        font-weight: 900;
      }

      .min-title {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 3px;
        text-indent: 2px;
      }
    }
  }

  .login-center {
    width: 500px;
    height: 690px;
    border-radius: 20px 20px 0 0;

    .login-form {
      width: 486px;
      height: 690px;
      position: relative;
      overflow: visible;
      background: #f8f9fd;
      --background: linear-gradient(0deg,
          rgb(228, 250, 253) 0%,
          rgb(244, 247, 251) 100%);
      padding: 100px 70px;
      border-radius: 0 10px 10px 0;
      box-sizing: border-box;
      z-index: 8;

      .icon {
        width: 24px;
        height: 25px;
        background-size: 100% 100%;
        background-position: center center;
        left: 0;
      }

      .user {
        position: absolute;
        left: 10px;
        background-image: url("../assets/img/l1.png");
      }

      .passo {
        position: absolute;
        left: 10px;
        background-image: url("../assets/img/l2.png");
      }

      .captcha {
        position: absolute;
        top: 15px;
        left: 10px;
        background-image: url("../assets/img/l3.png");
      }


      .itemli {
        border-radius: 4px;
        margin-bottom: 35px;
      }

      .login-btn {
        position: relative;
        height: 55px;
        font-size: 16px;
        border-radius: 0.5rem;
        color: #ffffff;
        transition: all 0.25s ease;
        background: radial-gradient(65.28% 65.28% at 50% 100%,
            rgba(113, 215, 255, 0.8) 0%,
            rgba(223, 113, 255, 0) 100%),
          linear-gradient(0deg, #2989f7, #2989f7);
        overflow: hidden;
      }

      .btn {
        height: 55px;
        position: absolute;
        top: 0;
        background-color: transparent;
        color: #fff;
        font-size: 18px;
        border: none;
        z-index: 9999;
        display: flex;
        align-items: center;
        line-height: 55px;
      }

      .input-glow {
        position: relative;
        border-radius: 0.5rem;
        padding: 2px;
        background: linear-gradient(45deg, #2f6dfd, #9ac7fa, #00f5ff, #165dff);
        background-size: 300% 300%;
        animation: glowBorder 3s ease infinite;
        overflow: hidden;
        display: flex;
        align-items: center;
      }
      .eye{
        position: absolute;
        right: 20px;
        font-size: 18px;
      }

      .input-glow-code,
      .getcode-btn {
        position: relative;
        border-radius: 0.5rem;
        padding: 2px;
        background: linear-gradient(45deg, #2f6dfd, #9ac7fa, #00f5ff, #165dff);
        background-size: 300% 300%;
        animation: glowBorder 3s ease infinite;
        overflow: hidden;
      }

      .code-card {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .input-glow-code {
        position: relative;
        width: 66%;
        height: 100%;
      }

      .getcode-btn {
        width: 30%;
        border-radius: 0.5rem;
        background-color: #fff;

        img {
          background-color: #fff;
          width: 100%;
          height: 50px;
          border-radius: 0.5rem;
        }
      }

      .form-input {
        width: 100%;
        height: 50px;
        margin: auto;
        padding: 2px 39px;
        border-radius: 0.375rem;
        border: none;
        outline: none;
        transition: all 0.3s ease;
      }

      .form-input:focus {
        box-shadow: 0 0 20px rgba(22, 93, 255, 0.5);
      }

      @keyframes glowBorder {
        0% {
          background-position: 0% 50%;
        }

        50% {
          background-position: 100% 50%;
        }

        100% {
          background-position: 0% 50%;
        }
      }

      .htit {
        font-size: 38px;
        font-weight: bold;
        background: linear-gradient(45deg, #0026ff, #33a3ff, #00ccff);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
        line-height: 40px;
        margin-bottom: 70px;
        text-align: center;
      }
    }

    .login-form:hover::after {
      opacity: 0;
    }
  }
}

.login-center-mobile {
  width: 380px;
  height: 440px;
  position: absolute;
  top: 36%;
  left: 50%;
  transform: translate(-50%, -50%);

  .title {
    text-align: center;
    color: #ffffff;
    margin-bottom: 40px;

    .main-title {
      margin-bottom: 10px;
      font-size: 34px;
      font-weight: 900;
    }

    .min-title {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 2px;
      text-indent: 2px;
    }
  }

  /* 移动端样式（屏幕宽度 ≤ 768px 时生效） */
  @media (max-width: 768px) {
    .title {
      color: #ffffff;
    }

    .title {
      background: linear-gradient(45deg, #0026ff, #33a3ff, #027491);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    }
  }

  .login-form-mobile {
    width: 380px;
    height: 440px;
    position: relative;
    overflow: visible;
    background: #f8f9fd;
    --background: linear-gradient(0deg,
        rgb(228, 250, 253) 0%,
        rgb(244, 247, 251) 100%);
    padding: 35px 40px 0 40px;
    border-radius: 10px;
    box-sizing: border-box;
    z-index: 8;

    .icon-mobile {
      width: 24px;
      height: 25px;
      background-size: 100% 100%;
      background-position: center center;
      left: 0;
    }

    .user {
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url("../assets/img/l1.png");
    }

    .passo {
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url("../assets/img/l2.png");
    }

    .captcha {
      position: absolute;
      top: 10px;
      left: 10px;
      background-image: url("../assets/img/l3.png");
    }

    .itemli {
      border-radius: 4px;
      margin-bottom: 35px;
    }

    .login-btn-mobile {
      position: relative;
      height: 45px;
      font-size: 16px;
      border-radius: 0.5rem;
      color: #ffffff;
      transition: all 0.25s ease;
      background: radial-gradient(65.28% 65.28% at 50% 100%,
          rgba(113, 215, 255, 0.8) 0%,
          rgba(223, 113, 255, 0) 100%),
        linear-gradient(0deg, #2989f7, #2989f7);
      overflow: hidden;
    }

    .btn-code {
      height: 45px;
      position: absolute;
      top: 0;
      background-color: transparent;
      color: #fff;
      border: none;
      z-index: 9999;
      display: flex;
      align-items: center;
      line-height: 45px;
    }

    .input-glow {
      position: relative;
      border-radius: 0.5rem;
      padding: 2px;
      background: linear-gradient(45deg, #2f6dfd, #9ac7fa, #00f5ff, #165dff);
      background-size: 300% 300%;
      animation: glowBorder 3s ease infinite;
      overflow: hidden;
    }
    .eye{
      position: absolute;
      top:5px;
      right: 15px;
      font-size: 18px;
    }
    .input-glow-code,
    .getcode-btn {
      position: relative;
      border-radius: 0.5rem;
      padding: 2px;
      background: linear-gradient(45deg, #2f6dfd, #9ac7fa, #00f5ff, #165dff);
      background-size: 300% 300%;
      animation: glowBorder 3s ease infinite;
      overflow: hidden;
    }

    .code-card {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .input-glow-code {
      width: 66%;
      height: 100%;
    }

    .getcode-btn {
      width: 30%;
      height: 100%;
      border-radius: 0.5rem;
      background-color: #fff;

      img {
        background-color: #fff;
        width: 100%;
        height: 44px;
        border-radius: 0.5rem;
      }
    }

    .form-input {
      width: 100%;
      padding: 2px 39px;
      border-radius: 0.375rem;
      border: none;
      outline: none;
      transition: all 0.3s ease;
    }

    .form-input:focus {
      box-shadow: 0 0 20px rgba(22, 93, 255, 0.5);
    }

    @keyframes glowBorder {
      0% {
        background-position: 0% 50%;
      }

      50% {
        background-position: 100% 50%;
      }

      100% {
        background-position: 0% 50%;
      }
    }

    .htit {
      font-size: 30px;
      font-weight: bold;
      background: linear-gradient(45deg, #0026ff, #33a3ff, #00ccff);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
      line-height: 30px;
      margin-bottom: 30px;
      text-align: center;
    }
  }

  .login-form:hover::after {
    opacity: 0;
  }
}
</style>
